$('#quick-view-modal').removeClass('fade');